/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Linux_Flatpak_DescInputs */

const en_pc_dl_file_linux_flatpak_desc = /** @type {(inputs: Pc_Dl_File_Linux_Flatpak_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxed. Install with flatpak install --user.`)
};

const zh_pc_dl_file_linux_flatpak_desc = /** @type {(inputs: Pc_Dl_File_Linux_Flatpak_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沙盒运行，用 flatpak install --user 安装。`)
};

/**
* | output |
* | --- |
* | "Sandboxed. Install with flatpak install --user." |
*
* @param {Pc_Dl_File_Linux_Flatpak_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_linux_flatpak_desc = /** @type {((inputs?: Pc_Dl_File_Linux_Flatpak_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Linux_Flatpak_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_linux_flatpak_desc(inputs)
	return zh_pc_dl_file_linux_flatpak_desc(inputs)
});
export { pc_dl_file_linux_flatpak_desc as "pc.dl.file.linux_flatpak.desc" }